import type { IPredominantLandAreaProps } from "./types";

export function PredominantLandArea({HOUSES_IN_AREA,infocusID}: IPredominantLandAreaProps) {
    return (
        <div data-infocusID={infocusID === 7}
            className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-col justify-between gap-4 p-8 bg-white
                page-break
            "
        >
            <div className="w-full flex flex-col justify-between gap-16">
                <span className="w-full h-auto flex flex-col  gap-4">
                    <span className="text-5xl">Área do terreno predominante</span>
                </span>
            </div>

            <div className="w-full overflow-x-auto flex flex-row flex-wrap items-baseline justify-center  py-[10%] gap-4"
                style={
                    {
                        height: 'calc(100vh - 172px)'
                    }
                }
            >
                {
                    Object.entries(HOUSES_IN_AREA).map((d, _i) => (
                            <span
                            key={d[0]}
                            className="min-w-[40%] w-[40%] max-h-[400px]  shadow-sm  hover:z-[999]
                                text-md font-normal border
                                border-gray-200 rounded-lg bg-white flex flex-col gap-4 p-3
                            "
                        >
                            <span className="flex flex-col gap-1">
                                <span className="text-md font-semibold text-gray-900">Metragem</span>
                                <span  className="text-md font-normal text-gray-400">
                                    {d[1].rangeRaw.join(' - ')}m² com {d[1].count} casa(s)
                                </span>
                            </span>

                            <span className="w-full flex-1 overflow-y-auto rounded-md">
                                {
                                    d[1].houses.map(house => (
                                        <span key={house?.id} className="w-full h-auto odd:bg-gray-100 rounded-md p-2 flex flex-row flex-flex-nowrap">
                                            <span className="w-full h-auto flex flex-row items-center gap-2">
                                                <span className="flex flex-col gap-2">
                                                    <span className="text-md font-semibold text-gray-900">Nome</span>
                                                    <span  className="text-md font-normal text-gray-500">
                                                        {house?.name || 'N/A'}
                                                    </span>
                                                </span>
                                            </span>

                                            <span className="w-full h-auto flex flex-row items-center gap-2">
                                                <span className="flex flex-col gap-2">
                                                    <span className="text-md font-semibold text-gray-900">Área de terrno</span>
                                                    <span  className="text-md font-normal text-gray-500">
                                                        {
                                                            Intl.NumberFormat('pt-BR', {
                                                                style: 'unit',
                                                                unit: 'meter'
                                                            }).format(house?.house_area || 0)
                                                        }
                                                    </span>
                                                </span>
                                            </span>
                                            <span className="w-full h-auto flex flex-row items-center gap-2">
                                                <span className="flex flex-col gap-2">
                                                    <span className="text-md font-semibold text-gray-900">Área construida</span>
                                                    <span  className="text-md font-normal text-gray-500">
                                                        {
                                                            Intl.NumberFormat('pt-BR', {
                                                                style: 'unit',
                                                                unit: 'meter'
                                                            }).format(house?.terrain_area || 0)
                                                        }
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                    ))
                                }

                                {/* {Array(20).fill(null).map((_d, i) => (
                                        <span key={i} className="w-full h-auto odd:bg-gray-100 rounded-md p-2 flex flex-row flex-flex-nowrap">
                                            <span className="w-full h-auto flex flex-row items-center gap-2">
                                                <span className="flex flex-col gap-2">
                                                    <span className="text-md font-semibold text-gray-900">Nome</span>
                                                    <span  className="text-md font-normal text-gray-500">
                                                        {i}
                                                    </span>
                                                </span>
                                            </span>

                                            <span className="w-full h-auto flex flex-row items-center gap-2">
                                                <span className="flex flex-col gap-2">
                                                    <span className="text-md font-semibold text-gray-900">Área de terrno</span>
                                                    <span  className="text-md font-normal text-gray-500">
                                                        {
                                                            Intl.NumberFormat('pt-BR', {
                                                                style: 'unit',
                                                                unit: 'meter'
                                                            }).format(i)
                                                        }
                                                    </span>
                                                </span>
                                            </span>
                                            <span className="w-full h-auto flex flex-row items-center gap-2">
                                                <span className="flex flex-col gap-2">
                                                    <span className="text-md font-semibold text-gray-900">Área construida</span>
                                                    <span  className="text-md font-normal text-gray-500">
                                                        {
                                                            Intl.NumberFormat('pt-BR', {
                                                                style: 'unit',
                                                                unit: 'meter'
                                                            }).format(i)
                                                        }
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                ))} */}
                            </span>
                        </span>
                    ))
                }
            </div>

            <div className="flex-1 w-full overflow-auto flex flex-row items-center justify-center">
                <canvas id="property-area-build"></canvas>
            </div>
        </div>
    )
}
